const aname = "Comp one";

const bname = "Comp two";

function myName(){
    let name = "M Moobeen"
    return name;
}

export default aname;

export {bname,myName};